var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-start-date.ce708e35.png","uri@2x": __webpack_public_path__ + "icon-start-date.abfd42d0.png","uri@3x": __webpack_public_path__ + "icon-start-date.fb13f36b.png",
    width: 20,
    height: 20
});